import _ from '@lodash';

const defaultMap = obj => obj.name;

export const findObjectNameById = (list, id, mapFn = defaultMap) => {
  if (!id) {
    return 'Unknown';
  }
  id = id.toString();
  const obj = _.find(list, l => l.id.toString() === id);
  if (!obj) {
    return 'Unknown';
  }
  return mapFn(obj);
};

export const arrayIsNotEmptyInPath = (array, path) => !arrayIsEmptyInPath(array, path);

export const arrayIsEmptyInPath = (array, path) => _.isEmpty(_.get(array, path));
